import React from 'react';
import FileUploader from './FileUploader';

const MultiFileUploader = (props) => (<FileUploader onDelete={props.onDelete} multipleLoading {...props} />);

// @todo: не работает ручка /uploadfile
// @todo: функция, которая будет удалять файлы

export default MultiFileUploader;